export default {
      id: "favorite-disactive-usage",
      viewBox: "0 0 21 27",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#favorite-disactive",
      toString: function () {
        return this.url;
      }
    }